export { default as LandingPageTokenHeader } from './LandingPageTokenHeader';
